import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import styled, { ThemeProvider } from 'styled-components';
import LinearProgress from 'material-ui/LinearProgress';
import { theme, muiTheme } from './utils/getTheme';
import { auth } from './utils/configureFirebase';
import Login from './views/Login';
import Secure from './views/Secure';
import CreateDrive from './views/CreateDrive';
import NotFound from './views/NotFound';
import SavedDrives from './views/SavedDrives';
import DriveDetails from './views/DriveDetails';
import EarlyBirdCandidate from './views/EarlyBirdCandidate';
import EventCampaign from './views/EventCampaign';
import {
  EarlyBirdCorporate,
  EarlyBirdCorporateEdit,
} from './views/EarlyBirdCorporate';
import {
  EarlyBirdCollege,
  EarlyBirdCollegeEdit,
} from './views/EarlyBirdCollege';
import CollegeStudentView from './views/CollegeStudentView';
import EarlyBirdCorporateConnect from './views/EarlyBirdCorporateConnect';
import NoAccess from './views/NoAccess';
import isAdmin from './utils/isAdmin';

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
`;

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAuthenticating: true,
      user: undefined,
    };

    this.authUnsubscribe = undefined;
  }

  componentDidMount() {
    this.authUnsubscribe = auth.onAuthStateChanged((user) => {
      this.setState(() => ({
        isAuthenticating: false,
        user,
      }));
    });
  }

  componentWillUnmount() {
    this.authUnsubscribe();
  }

  getView = () => {
    const { isAuthenticating, user } = this.state;

    if (isAuthenticating) {
      return (
        <LoaderWrapper>
          <LinearProgress
            mode="indeterminate"
            style={{
              width: '80%',
            }}
          />
        </LoaderWrapper>
      );
    }

    if (user) {
      if (isAdmin(user)) {
        return (
          <div>
            <Switch>
              <Route
                path="/"
                exact
                render={({ history }) => (
                  <Secure user={user}>
                    <CreateDrive history={history} />
                  </Secure>
                )}
              />
              <Route
                path="/event/campaign"
                render={({ history }) => (
                  <Secure user={user}>
                    <EventCampaign history={history} />
                  </Secure>
                )}
              />
              <Route
                path="/all"
                render={({ history }) => (
                  <Secure user={user}>
                    <SavedDrives history={history} />
                  </Secure>
                )}
              />
              <Route
                path="/drive/edit/:driveId"
                render={({ match: { params }, history }) => (
                  <Secure user={user}>
                    <CreateDrive
                      editable
                      driveId={params.driveId}
                      history={history}
                    />
                  </Secure>
                )}
              />
              <Route
                path="/drive/:driveId"
                render={({ match: { params } }) => (
                  <Secure user={user}>
                    <DriveDetails driveId={params.driveId} />
                  </Secure>
                )}
              />

              <Route
                path="/campus/data/:id"
                render={({ match, history }) => (
                  <Secure user={user}>
                    <EarlyBirdCandidate match={match} history={history} />
                  </Secure>
                )}
              />

              <Route
                path="/campuscape/corporate"
                render={({ history }) => (
                  <Secure user={user}>
                    <EarlyBirdCorporate history={history} />
                  </Secure>
                )}
              />

              <Route
                path="/campuscape/connectcorporate"
                render={({ history }) => (
                  <Secure user={user}>
                    <EarlyBirdCorporateConnect history={history} />
                  </Secure>
                )}
              />

              <Route
                path="/campuscape/campus"
                render={({ history }) => (
                  <Secure user={user}>
                    <EarlyBirdCollege history={history} />
                  </Secure>
                )}
              />

              <Route
                path="/campuscape/college/student"
                render={({ history }) => (
                  <Secure user={user}>
                    <CollegeStudentView history={history} />
                  </Secure>
                )}
              />

              <Route
                path="/edit/college/:id"
                render={({ history, match }) => (
                  <Secure user={user}>
                    <EarlyBirdCollegeEdit history={history} match={match} />
                  </Secure>
                )}
              />

              <Route
                path="/edit/corporate/:id"
                render={({ history, match }) => (
                  <Secure user={user}>
                    <EarlyBirdCorporateEdit history={history} match={match} />
                  </Secure>
                )}
              />

              <Route component={NotFound} />
            </Switch>
          </div>
        );
      }
      return <NoAccess />;
    }

    return <Login />;
  };

  render() {
    return (
      <ThemeProvider theme={theme}>
        <MuiThemeProvider muiTheme={muiTheme}>
          {this.getView()}
        </MuiThemeProvider>
      </ThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js